"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const IMAGE_BASE = "/image/new-version/casting/Sand-Casting/Applications";

const CATEGORIES = [
	{
		keyPrefix: "applicationsCat1",
		image: `${IMAGE_BASE}/automotive-transportation.webp`,
		href: "/industry/automotive",
	},
	{
		keyPrefix: "applicationsCat2",
		image: `${IMAGE_BASE}/aerospace-defense.webp`,
		href: "/industry/aerospace",
	},
	{
		keyPrefix: "applicationsCat3",
		image: `${IMAGE_BASE}/heavy-machinery-equipment.webp`,
		href: "/industry/industry-equipment",
	},
	{
		keyPrefix: "applicationsCat4",
		image: `${IMAGE_BASE}/industrial-machinery-automation.webp`,
		href: "/industry/industry-equipment",
	},
	{
		keyPrefix: "applicationsCat5",
		image: `${IMAGE_BASE}/energy-power-generation.webp`,
		href: "/industry/renewable-energy",
	},
	{
		keyPrefix: "applicationsCat6",
		image: `${IMAGE_BASE}/pump-valve-manufacturing.webp`,
		href: "/industry/industry-equipment",
	},
] as const;

const CARD_ORDER = [1, 4, 0, 3, 2, 5] as const;

export default function SandCastingApplications() {
	const t = useTranslations("new-sand-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)] lg:gap-10 xl:gap-12">
					<div>
						<p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-themePrimary400 sm:text-sm">
							{t("applicationsEyebrow")}
						</p>
						<h2 className="mb-4 text-2xl font-bold leading-tight text-black sm:mb-5 sm:text-[30px] md:text-4xl">
							{t("applicationsTitle")}
						</h2>
						<p className="mb-6 text-sm leading-relaxed text-black sm:mb-8 md:mb-10 md:text-base">
							{t("applicationsDesc")}
						</p>
						<div className="grid grid-cols-1 gap-x-10 gap-y-6 sm:grid-cols-2">
							{CATEGORIES.map((cat) => (
								<div key={cat.keyPrefix}>
									<h3 className="mb-2 text-base font-bold text-themePrimary400 sm:text-lg">
										{t(`${cat.keyPrefix}Title` as any)}
									</h3>
									<p className="text-sm leading-relaxed text-black md:text-base">
										{t(`${cat.keyPrefix}Desc` as any)}
									</p>
								</div>
							))}
						</div>
					</div>

					<div className="grid grid-cols-2 gap-3 sm:gap-4 md:gap-5 lg:self-end">
						{CARD_ORDER.map((idx, i) => {
							const cat = CATEGORIES[idx];
							const isHighlighted = i === CARD_ORDER.length - 1;
							return (
								<Link
									key={cat.keyPrefix}
									href={cat.href}
									className={`group flex min-h-[136px] flex-col rounded-xl p-3 transition-colors duration-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-themePrimary400 sm:min-h-[156px] sm:p-4 ${
										isHighlighted ? "bg-themePrimary400" : "bg-[#f2f2f2] hover:bg-themePrimary400"
									}`}
								>
									<div className="relative h-14 w-14 shrink-0 overflow-hidden rounded-full bg-white shadow-sm ring-1 ring-black/5 sm:h-[72px] sm:w-[72px]">
										<Image
											src={cat.image}
											alt={t(`${cat.keyPrefix}ImageAlt` as any)}
											fill
											className="object-cover"
											sizes="(max-width: 640px) 56px, 72px"
										/>
									</div>
									<h3
										className={`mt-auto max-w-[11rem] self-end pt-3 text-right text-xs font-bold leading-snug transition-colors duration-300 sm:max-w-[13rem] sm:pt-4 sm:text-sm ${
											isHighlighted ? "text-white" : "text-black group-hover:text-white"
										}`}
									>
										{t(`${cat.keyPrefix}Title` as any)}
									</h3>
								</Link>
							);
						})}
					</div>
				</div>
			</div>
		</section>
	);
}
